import Card from "@mui/material/Card/Card";
import CardHeader from "@mui/material/CardHeader/CardHeader";
import IconButton from "@mui/material/IconButton/IconButton";
import EditNoteIcon from '@mui/icons-material/EditNote';
import SettingsIcon from '@mui/icons-material/Settings';
import CardContent from "@mui/material/CardContent/CardContent";
import { Avatar, Box, Button, Drawer, Stack, TextField, Tooltip, Typography } from "@mui/material";
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import avatarTest from '../images/others/avatar.png';
import workerAvatar from '../images/others/workerAvatar.png';
import { useEffect, useRef, useState } from "react";
import './acordiationStyle.css';
import clsx from "clsx";
import { Tree } from "react-d3-tree";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import './custom-tree.css';
import { makeStyles } from "@mui/styles";
import { ElementInfo } from "components/ElementInfo";
import { getDataSource } from "api/ds";
import SearchIcon from '@mui/icons-material/Search';
import { Helmet } from "react-helmet";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CloseIcon from '@mui/icons-material/Close';
import UserAvatar from "components/EIComponents/UserAvatar";
import Loading from "components/Load";
import { get, getFile, post } from "api/apiBridges/httpBridge";
import { useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import { ShowModal } from 'components/Modal';

// анимации для стрелок (разворота дерева)
const useStyles = makeStyles((theme) => ({
  openX: {
    transform: "scaleX(1)"
  },
  closeX: {
    transform: "scaleX(-1)"
  },
  openY: {
    transform: "scaleY(1)"
  },
  closeY: {
    transform: "scaleY(-1)"
  }
}));

// Обёртка аккордеон для карточки
const AccordionItemBarcode = ({ child, subchild }) => {
  const [active, setActive] = useState(false);

  const handleItemClick = () => {
    setActive(false);
  };

  const handleItemClick1 = () => {
    setActive(true);
  };

  const contentHeight = useRef(null);
  return (
    <div className="wrapper" onMouseLeave={handleItemClick} style={{ textAlign: 'center' }}>
      <div className="answer-content" onMouseEnter={handleItemClick1}>
        {child}
      </div>
      <div 
        ref={contentHeight} 
        className="answer-container" 
        style={{
          height: active ? contentHeight.current?.scrollHeight : "0px",
          overflow: "hidden",
          transition: "height 0.3s ease-in-out"
        }}
      >
        <div style={{ paddingTop: '3px' }}> 
          {subchild}
        </div>
      </div>
    </div>
  )
}


// todo выбор цвета от роли
// карточка сотрудника
const CardWorker = ({ data, toggle, openModal, set, canChange}) => {

  console.log("CardWorker", data)
  const [open, setOpen] = useState(false);
  
  // useEffect(() => {
  //   const fetchData = async () => {

  //       try {
  //         if (data.user?.avatar) {
  //           console.log("data.user", data.user)
  //           let res = await getFile("png", {path: data.user.avatar})
  //           console.log("data.user res", typeof res)
  //           if (typeof res === 'string') {
  //             setAvatar(res)
  //           }
  //         }
  //       } catch (err) {
  //       } 

        
  //   };   
    
  //   fetchData();
  // }, [data]); 

  const classes = useStyles();

  //Автоматически раскрывает ветку, если она коллапсирована и не является последней
  if (data.__rd3t.collapsed === true && open === false && (data?.end === undefined || data?.end === false)) {
    toggle();
  }

  const toggleNode = () => {
    toggle();
    setOpen(!open);
  }

  // Добавление. Также открывается шторка
  const AddNode = () => {
    openModal({ open: true, ds: 'addWorker', data: { idParent: data.id, parentStatus: data.status, childCount: data.children.length, set} })
  }

  // Редактировать. Открывается шторка с данными сотрудника
  const EditNode = () => {
    openModal({ open: true, ds: 'editWorker', data: { ...data, set } })
  }

  return (
    <AccordionItemBarcode child={
      <Card style={{ border: data?.find ? '4px solid #ffa440' : '0px' }}>
        <CardHeader
          style={{ backgroundColor: data.color || '#e087e8', color: 'white', fontStyle: 'normal' }}
          action={
            <div>
              {
                canChange && 
                <IconButton aria-label="settings" onClick={EditNode}>
                  <SettingsIcon color="info"></SettingsIcon>
                </IconButton>
              }
              {data?.end === true ? <></> : <IconButton aria-label="settings" onClick={toggleNode} id={`toggleButton${data.user.fio}`}>
                <KeyboardArrowDownIcon className={clsx(!open && classes.closeY, open && classes.openY)} ></KeyboardArrowDownIcon>
              </IconButton>}
            </div>

          }
          title={data.role}
        />
        <CardContent style={{ fontStyle: 'normal' }}>
          <Stack direction="row" spacing={2}>
            <UserAvatar src={data.user?.avatar || ""} userData={data.user} user_id={data.user_id} size={56} marginRight="10px"/>
            {/* <Avatar sx={{ width: 56, height: 56 }} src={data?.avatar || workerAvatar}></Avatar> */}
            <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'start' }}>
              <Typography variant="h6" style={{ marginBottom: '0px', fontWeight: 'bold', color: 'black' }}>{data.user.fio}</Typography>
              {/* <Typography variant="subtitle2" style={{ marginBottom: '5px', fontWeight: 'normal', color: 'black' }}>{data.date}</Typography> */}
              <div style={{ display: 'flex' }}>
                <Typography variant="subtitle2">{`ЗП:\u2002`}</Typography>
                <Typography variant="subtitle2" color='black'>{data.zp}</Typography>
              </div>
              <div style={{ display: 'flex' }}>
                <Typography variant="subtitle2">{`Оклад:\u2002`}</Typography>
                <Typography variant="subtitle2" color='black'>{data.oklad}</Typography>
              </div>
              <div style={{ display: 'flex' }}>
                <Typography variant="subtitle2">{`Проценты:\u2002`}</Typography>
                <Typography variant="subtitle2" color='black'>{`${data.percent}%`}</Typography>
              </div>
            </div>
          </Stack>
        </CardContent>
      </Card>
    } subchild={
      canChange? <Add AddNode={AddNode}></Add>: undefined
    }>

    </AccordionItemBarcode>

  );
};




// todo изменить в id на уникальный идентификатор
// карточка отдела
// такие же функции как у работника
const CardDepartment = ({ data, toggle, openModal, set, canChange }) => {

  const [open, setOpen] = useState(false);

  const classes = useStyles();
  // console.log('openDep', data.__rd3t);
  if (data.__rd3t.collapsed === true && open === false && (data?.end === undefined || data?.end === false)) {
    // console.log('openDep');
    toggle();
    // setOpen(!open);
  }

  const toggleNode = () => {
    toggle();
    setOpen(!open);

  }

  // Добавление. Также открывается шторка
  const AddNode = () => {
    openModal({ open: true, ds: 'addWorker', data: { idParent: data.id, parentStatus: data.status, childCount: data.children.length, set} })
  }

  // Редактировать. Открывается шторка с данными сотрудника
  const EditNode = () => {
    openModal({ open: true, ds: 'editWorker', data: { ...data, set } })
  }

  return (
    <AccordionItemBarcode child={
      <Card style={{ border: data?.find ? '4px solid #ffa440' : '0px' }}>
        <CardHeader
          style={{ backgroundColor: data.color || '#e087e8', color: 'white', fontStyle: 'normal' }}
          action={
            <div style={{ display: 'flex' }}>
              {
                canChange &&
                <IconButton aria-label="settings" onClick={EditNode}>
                <SettingsIcon color="info"></SettingsIcon>
              </IconButton>
              }
              <IconButton aria-label="settings" onClick={toggleNode} id={`toggleButton${data.name}`}>
                <KeyboardArrowDownIcon className={clsx(!open && classes.closeY, open && classes.openY)} ></KeyboardArrowDownIcon>
              </IconButton>
            </div>
          }
          title={data.name}
        />
      </Card>
    }
      subchild={canChange? <Add AddNode={AddNode}></Add>: undefined}
    />
  );
}

// тестовые данные
const dataCompany = {
  avatar: avatarTest, name: "Company"
}

const dataWorkers =
{
  role: 'BIG BOSS', avatar: avatarTest, user: {name: 'J. Jonah Jameson'}, zp: 100000, oklad: 100000, percent: 10, type: 'worker', id: 1, date: '01.01.1970', children: [
    // {
    //   type: 'department', name: 'Logistic', id: 2, children: [
    //     { role: 'BIG BOSS', name: 'J. Jonah Jameson2', zp: 100000, oklad: 100000, percent: 10, type: 'worker', end: true, id: 3, date: '01.01.1970' },
    //     { role: 'BIG BOSS', name: 'J. Jonah Jameson2', zp: 100000, oklad: 100000, percent: 10, type: 'worker', end: true, id: 11, date: '01.01.1970' },
    //   ]
    // },
    // {
    //   type: 'department', name: 'Logistic', id: 4, children: [
    //     {
    //       role: 'BIG BOSS', avatar: avatarTest, id: 5, name: 'J. Jonah Jameson3', zp: 100000, oklad: 100000, percent: 10, type: 'worker', date: '01.01.1970', children: [
    //         { role: 'BIG BOSS', avatar: avatarTest, id: 6, name: 'J. Jonah Jameson4', zp: 100000, oklad: 100000, percent: 10, type: 'worker', date: '01.01.1970', end: true },
    //         { role: 'BIG BOSS', avatar: avatarTest, id: 7, name: 'J. Jonah Jameson4', zp: 100000, oklad: 100000, percent: 10, type: 'worker', date: '01.01.1970', end: true },
    //         { role: 'BIG BOSS', avatar: avatarTest, id: 8, name: 'J. Jonah Jameson4', zp: 100000, oklad: 100000, percent: 10, type: 'worker', date: '01.01.1970', end: true },
    //         {
    //           role: 'BIG BOSS', avatar: avatarTest, id: 9, name: 'J. Jonah Jameson4', zp: 100000, oklad: 100000, percent: 10, type: 'worker', date: '01.01.1970', children: [
    //             {
    //               type: 'department', name: 'Logistic', id: 12, children: [
    //                 { role: 'BIG BOSS', name: 'J. Jonah Jameson2', zp: 100000, oklad: 100000, percent: 10, type: 'worker', end: true, id: 13, date: '01.01.1970' },
    //                 { role: 'BIG BOSS', name: 'J. Jonah Jameson2', zp: 100000, oklad: 100000, percent: 10, type: 'worker', end: true, id: 14, date: '01.01.1970' },
    //               ]
    //             },
    //           ]
    //         },
    //         { role: 'BIG BOSS', avatar: avatarTest, id: 10, name: 'J. Jonah Jameson4', zp: 100000, oklad: 100000, percent: 10, type: 'worker', date: '01.01.1970', end: true },

    //       ],

    //     }
    //   ]
    // }

  ]
};

// добавление нового сотрудника или отдела
// todo передавать узел
const Add = ({ AddNode }) => {

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <Tooltip title="Добавить">
        <IconButton disableRipple sx={{ m: 0, p: 0, minWidth: 0 }} size="large" onClick={AddNode}>
          <ControlPointIcon style={{ fontSize: "2rem" }} color="primary" ></ControlPointIcon>
        </IconButton>
      </Tooltip>
    </div>
  );
}

const containerStyles = {
  width: "100vw",
  height: "100vh",
  id: 'containerOrg'
};

const renderForeignObjectNode = ({
  nodeDatum,
  toggleNode,
  foreignObjectProps
}) => {
  // разное расположения длдя типов карточек. по данной функции см доки библы
  const props = { x: foreignObjectProps.x, 
    height: nodeDatum.type !== 'worker' ? 150 : 320, 
    width: foreignObjectProps.width, 
    y: nodeDatum.type === 'worker' ? -80 : -40 }; //  y: nodeDatum.type !== 'worker' ? -80 : -foreignObjectProps.height/2

  // console.log('coord', nodeDatum, props.x, props.y);
  return (
    <g id={nodeDatum.id}>
      <foreignObject {...props}>
        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
          {nodeDatum.type === 'worker' ? <CardWorker openModal={foreignObjectProps.open} data={nodeDatum} toggle={toggleNode} set={foreignObjectProps.set} canChange={foreignObjectProps.canChange}></CardWorker> : <CardDepartment openModal={foreignObjectProps.open} data={nodeDatum} toggle={toggleNode}  set={foreignObjectProps.set} canChange={foreignObjectProps.canChange}></CardDepartment>}
        </div>
      </foreignObject>
    </g>
  );
};

function FindWorkersButton({ setOpen }) {
  return (
    <div style={{ marginBottom: '12px' }}>
      <Tooltip title="Поиск">
        <IconButton size="large" onClick={() => setOpen(true)}>
          <SearchIcon style={{ fontSize: "2rem" }} color="primary"></SearchIcon>
        </IconButton>
      </Tooltip>
    </div>
  );
}

// Окно поиска сотрудников
// Работает по name и role, поддерживает RegExp.
// Подсвечивает найденные элементы (el.find = true).
// Собирает координаты DOM-элементов найденных узлов и переносит к найденным
function FindWorkersWindow({ setOpen, data, setData, setTranslate }) {

  const [word, setWord] = useState(undefined);
  const [findCount, setFindCount] = useState({ current: 0, all: 0 });
  const [findCoord, setFindCoord] = useState([]);
  console.log('findCoord', findCoord);
  const $setWord = (word) => {
    if (word === undefined || word === "") {
      setWord(undefined);
    } else {

      setWord(new RegExp(`${word}+[a-zA-Z0-9А-Яа-яёЁ\-]*`, "i"));
    }

  }

  const getCoord = (x, y) => {
    return { x: (x * -1) + window.innerWidth / 2, y: -y + 200 }
  }

  const find = (data) => {
    if (word !== undefined) {

      if (Array.isArray(data)) {
        for (const el of data) {
          if (word.test(el.name) || word.test(el?.role)) {
            el.find = true;
            const element = document.getElementById(el.id);
            if (element !== null) {
              const style = element.parentElement.computedStyleMap().get('transform')[0];
              console.log('element', element);
              findCoord.push({ x: style.x.value, y: style.y.value });
            }

          } else {
            el.find = false;
          }
          if (el?.children) {
            find(el.children)
          }
        }
      } else {
        if (word.test(data.user.fio) || word.test(data?.role)) {
          data.find = true;
          const element = document.getElementById(data.id);
          if (element !== null) {
            const style = element.parentElement.computedStyleMap().get('transform')[0];
            console.log('element', element);
            findCoord.push({ x: style.x.value, y: style.y.value });
          }
        } else {
          data.find = false;
        }
        if (data?.children) {
          find(data.children)
        }
      }

      setData(JSON.parse(JSON.stringify(data)));
      setFindCoord(findCoord);
      setFindCount({ current: findCoord.length > 0 ? 1 : 0, all: findCoord.length });
      console.log('Coord11', findCoord);
      if (findCoord.length > 0) {
        setTranslate(JSON.parse(JSON.stringify(getCoord(findCoord[0].x, findCoord[0].y))));
      }

    } else {
      unFind(data);
    }
  }

  const unFind = (data) => {
    if (Array.isArray(data)) {
      for (const el of data) {

        el.find = false;
        if (el?.children) {
          unFind(el.children)
        }
      }
    } else {

      data.find = false;
      if (data?.children) {
        unFind(data.children)
      }
    }
    setData(JSON.parse(JSON.stringify(data)));
    setFindCount({ current: 0, all: 0 });
    setFindCoord([]);
  }

  const nextWorker = () => {
    if (findCount.all !== 0) {
      if (findCount.current === findCount.all) {
        setTranslate(JSON.parse(JSON.stringify(getCoord(findCoord[0].x, findCoord[0].y))));
        setFindCount(JSON.parse(JSON.stringify({ current: 1, all: findCount.all })));
      } else {
        setFindCount(JSON.parse(JSON.stringify({ current: findCount.current + 1, all: findCount.all })));
        setTranslate(JSON.parse(JSON.stringify(getCoord(findCoord[findCount.current].x, findCoord[findCount.current].y))));
      }

    }
  }

  const previousWorker = () => {
    if (findCount.all !== 0) {


      if (findCount.current === 1) {
        console.log('findCoordN', findCoord, findCount.all - 1);
        setFindCount(JSON.parse(JSON.stringify({ current: findCount.all, all: findCount.all })));
        setTranslate(JSON.parse(JSON.stringify(getCoord(findCoord[findCount.all - 1].x, findCoord[findCount.all - 1].y))));

      } else {
        console.log('findCoordN', findCoord[findCount.current], findCount.current);
        setTranslate(JSON.parse(JSON.stringify(getCoord(findCoord[findCount.current - 2].x, findCoord[findCount.current - 2].y))));
        setFindCount(JSON.parse(JSON.stringify({ current: findCount.current - 1, all: findCount.all })));
      }
    }
  }

  return (
    <div style={{
      backgroundColor: 'white', width: '300px',
      display: 'flex', flexDirection: 'column',
      borderRadius: 10
    }}>
      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <IconButton size="small" onClick={() => {
          unFind(data);
          setOpen(false);
        }}>
          <CloseIcon></CloseIcon>
        </IconButton>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', padding: '0% 4% 4% 4%' }}>
        <TextField
          placeholder='Поиск'
          variant="standard"
          helperText={`${findCount.current}/${findCount.all}`}
          // value={word}
          onChange={(e) => {
            $setWord(e.target.value);
          }}
          InputProps={{

            endAdornment: (
              <>
                <IconButton size="small" onClick={previousWorker}>
                  <KeyboardArrowUpIcon></KeyboardArrowUpIcon>
                </IconButton>
                <IconButton size="small" onClick={nextWorker}>
                  <KeyboardArrowDownIcon></KeyboardArrowDownIcon>
                </IconButton>
              </>
            )
          }}
        />
        <Button onClick={() => {findCoord.length=0; find(data) }} variant="contained" sx={{ height: '80%', textTransform: 'none', backgroundColor: '#078376', fontWeight: 'bold', marginLeft: '5px' }}>Нaйти</Button>
      </div>
    </div>
  );
}

function FindWorkers({ data, setData, setTranslate }) {

  const [open, setOpen] = useState(false);

  if (!open) {
    return (<FindWorkersButton setOpen={setOpen}></FindWorkersButton>);
  } else {
    return (<FindWorkersWindow setData={setData} data={data} setOpen={setOpen} setTranslate={setTranslate}></FindWorkersWindow>);
  }
}


//EDIT THIS
//здесь можно попробовать useState написать, но мб лучше затолкать setIsChanged
function EditRole({openModal, delRole, setIsChanged}) {
    // todo возможно другой дескриптор
    function EditWorkers() {
      openModal({ open: true, ds: 'roles', data: {delRole, setChanged: setIsChanged}})
    }
  return (
    <div style={{ marginLeft: 'auto' }}>
      <Tooltip title="Ред/добавить роль">
        <IconButton size="large" onClick={EditWorkers}>
          <EditNoteIcon style={{ fontSize: "2rem" }} color="primary"></EditNoteIcon>
        </IconButton>
      </Tooltip>
    </div>
  );
}

//или можно сюда передавать setIsChanged
function SearchEdit({ data, setData, setTranslate, openModal, delRole, setIsChanged}) {
  return (
    <div style={{ position: 'absolute', right: 0, display: 'flex', flexDirection: 'column' }}>
      <FindWorkers data={data} setData={setData} setTranslate={setTranslate}></FindWorkers>
      <EditRole openModal={openModal} delRole={delRole} setIsChanged={setIsChanged}></EditRole>
    </div>
  );
}



// дерево организации
export default function Workers() {

  const [open, setOpen] = useState({ open: false, ds: "addWorker", data: undefined });
  const [isChanged, setIsChanged] = useState(false);

  //todo delete json
  // const [data, setData] = useState(JSON.parse(JSON.stringify(dataWorkers)));

  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const { company_id, rules } = useSelector(
    loginSelector
  );

  const [canChange, setCanChange] = useState(rules.includes("admin") || rules.includes("company.change_workers"));
  // 
  // { x: (-600 * -1) + window.innerWidth / 2, y: 810 }
  const [translate, setTranslate] = useState({ x: window.innerWidth / 2, y: 120 });

  const toggleDrawer = (forceClose) => {
    // Если передали true, игнорируем isChanged и закрываем шторку
    if (isChanged && forceClose !== true) {
            ShowModal(
                'Несохраненные изменения',
                <div>У вас есть несохраненные данные. Вы уверены, что хотите закрыть окно без сохранения?</div>,
                async () => {
                    setIsChanged(false);
                    setOpen({ open: false, ds: undefined, data: undefined });
                }
            );
    } else {
            setOpen({ open: false, ds: undefined, data: undefined });
    }
  }

  const updateData = (inData) => {
    console.log('updateData0', inData)
    if (inData.del) {
      setData(inData.updatedData)
      return
    }
    if (inData.type === "worker") {
      //локальное изменение древа
      let stList = inData.status.split("_").slice(1)
      let tmp = JSON.parse(JSON.stringify(data))
      let target = tmp
      if (inData.status === "0") {
        tmp.role = inData.role
        tmp.zp = inData.zp
        tmp.oklad = inData.oklad
        tmp.percent = inData.percent
        tmp.roles = inData.roles
        tmp.color = inData.color
      }
      else {
        let status = "0_"
        for (let st of stList) {
          let idx = target.children.findIndex((fel) => fel.status === status+st)
          if (idx > -1) {
            //Обнволяем
            if (status+st === inData.status) {
              let old = JSON.parse(JSON.stringify(target.children[idx]))
              target.children[idx] = {
                ...old,
                role: inData.role,
                zp: inData.zp,
                oklad: inData.oklad,
                percent: inData.percent,
                roles: inData.roles,
                color: inData.color
              }
            }
            //Идем дальше
            else {
              target = target.children[idx]
              status += `${st}_`
            }
          }
          //Добавляем
          else {
            console.log('1_3')
            target.children.push(
              {
                user_id: inData.user_id,
                role: inData.role,
                user: {
                    avatar: "",
                    fio: inData.userInfo.fio,
                    email: inData.userInfo.email,
                    mobile_number: inData.userInfo.mobile_number
                },
                zp: inData.zp,
                oklad: inData.oklad,
                percent: inData.percent,
                type: "worker",
                id: inData.cwid,
                status: inData.status,
                children: [],
                roles: inData.roles,
                color: inData.color
              }
            )
          }
        }
      }
      console.log('updateData1', tmp)
      setData(tmp)
    }
    else {
      //локальное изменение древа
      let stList = inData.status.split("_").slice(1)
      let tmp = JSON.parse(JSON.stringify(data))
      let target = tmp
      let status = "0_"
      for (let st of stList) {
        let idx = target.children.findIndex((fel) => fel.status === status+st)
        if (idx > -1) {
          //Обнволяем
          if (status+st === inData.status) {
            console.log("update")
            let old = JSON.parse(JSON.stringify(target.children[idx]))
            console.log("old", old)
            target.children[idx] = {
              ...old,
              name: inData.name,
              color: inData.color
            }
          }
          //Идем дальше
          else {
            console.log("next step")
            target = target.children[idx]
            status += `${st}_`
          }
        }
        //Добавляем
        else {
          console.log("otdel")
          target.children.push(
            {
              user_id: inData.user_id,
              type: inData.type,
              id: inData.cwid,
              status: inData.status,
              children: [],
              name: inData.name,
              color: inData.color
            }
          )
        }
      }
      console.log('updateData1', tmp)
      setData(tmp)
    }
  }

  const nodeSize = { x: 240, y: 270 };
  const foreignObjectProps = { 
    width: nodeSize.x, 
    height: nodeSize.y, 
    x: -nodeSize.x / 2, 
    open: setOpen, 
    set:updateData, 
    canChange
  };

  useEffect(() => {
      const fetchData = async () => {
  
          try {
            setLoading(true);
            let res = await get("companyWorkers/getOnCompany", {cid:company_id})
            setData(res)
          } catch (err) {
          } finally {
          setLoading(false);
          }
  
          
      };   
      
      fetchData();
    }, []); 

  function getAllNodes(root) {
    const nodes = [];
    
    function collectNodes(node) {
        nodes.push(node);
        
        if (node.children && Array.isArray(node.children)) {
            node.children.forEach(child => {
                collectNodes(child);
            });
        }
    }
    
    collectNodes(root);
    return nodes;
  }

  const delRole = async (rid) => {
    try{
      setLoading(true)
      let tmp = JSON.parse(JSON.stringify(data))
      const allNodes = getAllNodes(tmp);
      let needNodes = allNodes.filter((el) => el.roles.includes(rid))
      console.log("needNodes", needNodes)

      await Promise.all(needNodes.map( async (el) => {

        await post("companyWorkers/update", {id: data.id, roles: el.roles.filter((fel) => fel !== rid) })  

        //локальное изменение древа
        let stList = el.status.split("_").slice(1)
        let target = tmp
        if (el.status === "0") {
          tmp.roles = tmp.roles.filter((fel) => fel !== rid)
        }
        else {
          let status = "0_"
          for (let st of stList) {
            let idx = target.children.findIndex((fel) => fel.status === status+st)
            //Обнволяем
            if (status+st === el.status) {
              target.children[idx].roles = tmp.roles.filter((fel) => fel !== rid)
            }
            //Идем дальше
            else {
              target = target.children[idx]
              status += `${st}_`
            }
          }
        }

      }))

      setData(tmp)
    }
    catch (err) {}
    finally {setLoading(false)}

  }

  console.log("data", data)

  if (loading) {
    return <Loading></Loading>
  }

  return (
    <div style={containerStyles}>
      {/* <Helmet>
        <title>Workers</title>
      </Helmet> */}
      {/* <HeaderCompany data={dataCompany} title={'Сотрудники'} child={<Company data={dataCompany}></Company>} ></HeaderCompany> */}
      <SearchEdit data={data} setData={setData} setTranslate={setTranslate} openModal={setOpen} delRole={delRole} setIsChanged={setIsChanged}></SearchEdit>
      <Tree
        rootNodeClassName="custom_root"
        branchNodeClassName="node__branch"
        leafNodeClassName="custom__leaf"
        translate={translate}
        pathFunc={"step"}

        data={data}
        nodeSize={nodeSize}
        // pathFunc={straightPathFunc}
        pathClassFunc={() => 'link__to-leaf'}
        separation={{ siblings: 2, nonSiblings: 2 }}
        renderCustomNodeElement={(rd3tProps) => {
          return renderForeignObjectNode({ ...rd3tProps, foreignObjectProps })
        }
        }
        orientation="vertical"
      />
      <Drawer
        anchor='right'
        open={open.open}
        onClose={toggleDrawer}
      >
        <ElementInfo ds={getDataSource(open.ds)} data={open.data} onClose={toggleDrawer} 
// @ts-ignore
        setChanged={setIsChanged}/>
      </Drawer>
    </div>
  );
}